import React from "react";
import "./TitleSection.css";
import { SchoolLogo } from "../../../assets/exports/FileExports";

const TitleSection = () => {
  return (
    <div className="school-title">
      <img
        rel="preload"
        fetchpriority="high"
        className="school-logo"
        src={SchoolLogo}
        alt="school logo"
      />

      <div className="school-name">
        <h1>Naveen Shiksha</h1>
        <p className="h1-secondary">Bharti Public School</p>
      </div>
    </div>
  );
};

export default TitleSection;
